import { render, staticRenderFns } from "./SelectorChipsFilter.vue?vue&type=template&id=f0f2a59e"
import script from "./SelectorChipsFilter.vue?vue&type=script&lang=js"
export * from "./SelectorChipsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports